import {source} from 'unist-util-source'
import {SKIP, visit} from 'unist-util-visit'

import type {CopilotMarkdownExtension, RehypeHtmlTransformer} from '../extension'
import {isTrustedMediaSource} from './trusted-media-domains'

/**
 * Requires that images in rendered markdown come from an explicitly allow-listed domain.
 */
const ensureTrustedSource: RehypeHtmlTransformer = (tree, file) =>
  visit(tree, (node, index, parent) => {
    if (node.type !== 'element') return
    if (node.tagName === 'img' && 'src' in node.properties) {
      const src = node.properties.src as string
      if (!isTrustedMediaSource(src)) {
        const md = source(file, node) ?? ''
        const spanNode = {
          type: 'element' as const,
          tagName: 'span',
          properties: {},
          children: [
            {
              type: 'text' as const,
              value: md,
            },
          ],
        }
        if (parent && typeof index === 'number') {
          parent.children[index] = spanNode
          return [SKIP, index]
        }
      }
    }
  })

export default function imagesExtension(): CopilotMarkdownExtension {
  return {
    transformHtml: ensureTrustedSource,
  }
}
